import { checkIsTicketTypeCoupon } from './checkCoupon';
import { createCartLineItem } from './createCartLineItem';
import getBulkDiscount from './getBulkDiscount';
import { getBulkDiscountsForTicketType } from './getBulkDiscountsForTicketType';
import { getCouponTicketTypeDiscount } from './getCouponTicketTypeDiscount';

export default function getTicketTypeLineItemsWithTotals(
  ticketTypes,
  ticketTypeDiscounts,
  coupon,
  taxRate,
  currency,
) {
  if (!ticketTypes || !ticketTypes.length) {
    return {
      totalTicketTypesAmount: 0,
      totalTicketTypesBulkDiscountAmount: 0,
      totalTicketTypesCouponDiscountAmount: 0,
      lineItems: [],
    };
  }

  return ticketTypes.reduce(
    (acc, ticketType) => {
      // Ensure price and quantity are numbers
      const price = Number(ticketType.price) || 0;
      const quantity = Number(ticketType.quantity) || 0;

      const bulkDiscountsToApply = getBulkDiscountsForTicketType(
        ticketTypeDiscounts,
        ticketType._id,
      );

      const ticketAmount = price * quantity;
      const { bulkDiscountAmount, bulkDiscount } = getBulkDiscount(
        bulkDiscountsToApply,
        quantity,
        ticketAmount,
      );

      const bulkDiscountAmountNumber = Number(bulkDiscountAmount) || 0;

      let couponDiscountAmountNumber = 0;
      if (checkIsTicketTypeCoupon(coupon)) {
        couponDiscountAmountNumber = getCouponTicketTypeDiscount({
          amount: ticketAmount - bulkDiscountAmountNumber,
          coupon,
          quantity,
          ticketTypeId: ticketType._id,
        });
      }

      const lineItem = createCartLineItem({
        type: 'ticket',
        id: ticketType._id,
        name: ticketType.name,
        description: ticketType.reference || ticketType.description,
        quantity,
        unitPrice: price,
        appliedBulkDiscountRule: bulkDiscount,
        appliedCoupon: coupon,
        bulkDiscountAmount,
        couponDiscountAmount: couponDiscountAmountNumber,
        currency,
        taxRate,
      });

      return {
        totalTicketTypesAmount: acc.totalTicketTypesAmount + ticketAmount,
        totalTicketTypesBulkDiscountAmount:
          acc.totalTicketTypesBulkDiscountAmount + bulkDiscountAmountNumber,
        totalTicketTypesCouponDiscountAmount:
          acc.totalTicketTypesCouponDiscountAmount + couponDiscountAmountNumber,
        lineItems: [...acc.lineItems, lineItem],
      };
    },
    {
      totalTicketTypesAmount: 0,
      totalTicketTypesBulkDiscountAmount: 0,
      totalTicketTypesCouponDiscountAmount: 0,
      lineItems: [],
    },
  );
}
